const KIND_LABELS: Record<string, string> = {
  OFFER_PUBLISH: 'Offer publishing',
  BANK_VERIFY: 'Trust bank verification',
  UNIT_ISSUE: 'Unit issue',
  LEDGER_REVERSAL: 'Ledger reversal',
  TEST: 'Test request',
};

export function approvalKindLabel(kind: string): string {
  return KIND_LABELS[kind] ?? kind.replace(/_/g, ' ').toLowerCase();
}

/** Formats the API's 2 dp decimal string as dollars without converting it to a float. */
export function formatAmount(amount: string | null): string | null {
  if (amount === null || amount === undefined || amount === '') return null;
  const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(amount.trim());
  if (!match) return amount;
  const [, sign, whole, fraction = ''] = match;
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${sign}$${grouped}.${fraction.padEnd(2, '0').slice(0, 2)}`;
}

const dateTimeFormatter = new Intl.DateTimeFormat('en-AU', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

/** A server timestamp shown in the viewer's local time. */
export function formatWhen(iso: string | null): string {
  if (!iso) return '—';
  const value = new Date(iso);
  return Number.isNaN(value.getTime()) ? iso : dateTimeFormatter.format(value);
}
